import type { CampaignAnalysisContentCreationGuide } from '@/entities/campaign/generated/campaign-type';
import { Badge } from '@/shared/components/shadcn/badge';

export function ContentGuideSection({
  content_creation_guides,
}: {
  content_creation_guides: readonly CampaignAnalysisContentCreationGuide[];
}) {
  return (
    <div className="flex flex-col gap-4">
      {content_creation_guides.map((item, index) => (
        <div
          key={item.title}
          data-campaign-analysis-content-guide-item
          data-campaign-analysis-print-avoid-break
          className="border-border bg-card grid gap-5 rounded-xl border p-5 shadow-sm sm:py-6 sm:pr-10 sm:pl-6 md:grid-cols-[28px_minmax(0,1fr)] print:gap-3 print:p-4"
        >
          <div className="text-foreground text-lg leading-6 font-bold tabular-nums">
            {index + 1}
          </div>
          <div className="flex min-w-0 flex-col gap-3">
            <div className="flex flex-wrap items-center gap-3">
              <Badge
                variant="secondary"
                className="rounded-full px-2.5 py-1 text-sm leading-5 font-semibold"
              >
                {item.label}
              </Badge>
              <p className="text-foreground min-w-0 text-lg leading-6 font-bold break-words">
                {item.title}
              </p>
            </div>
            <p className="text-muted-foreground max-w-4xl text-sm leading-6">{item.body}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
